import {
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import { CartableHistory } from "../../../models/settlement.model";
import TabsEmptyStyle from "../../permission/components/TabsEmptyStyle";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const columns = [
  { id: 0, title: "ردیف" },
  {
    id: 1,
    title: "گردش کار",
  },
  {
    id: 2,
    title: "تاریخ عملیات",
  },
  {
    id: 3,
    title: "کاربر",
  },
  {
    id: 4,
    title: "نوع عملیات",
  },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

interface Props {
  cartableHistory: CartableHistory[];
  handleMoreClick: Function;
}

const WorkflowTabTable = ({ cartableHistory, handleMoreClick }: Props) => {
  if (cartableHistory?.length === 0) {
    return (
      <TabsEmptyStyle
        height="100%"
        completeText="موردی به گردش کار اضافه نشد"
      />
    );
  }
  return (
    <div style={{ height: "100%" }}>
      <TableContainer
        component={Paper}
        sx={{ maxHeight: "80vh", width: "100%", height: "100%" }}
      >
        <Table
          stickyHeader
          sx={{
            minWidth: { xs: 0, sm: 0, md: 700, lg: 900 },
          }}
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              {columns.length > 0 &&
                columns.map((column) => (
                  <StyledTableCell align="center">
                    {column.title}
                  </StyledTableCell>
                ))}
              <StyledTableCell align="center">
                <MoreHorizIcon />
              </StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody
            sx={{
              outline: "1px solid #DAE0E4",
            }}
          >
            {cartableHistory?.map((item: CartableHistory, index) => (
              <StyledTableRow sx={{ cursor: "pointer" }}>
                <StyledTableCell align="center" scope="row">
                  <p
                    style={{
                      textAlign: "center",
                      marginBottom: "-.5vh",
                      color: "#34495E",
                    }}
                  >
                    {index + 1}
                  </p>
                </StyledTableCell>
                <StyledTableCell align="center" scope="row">
                  <p
                    style={{
                      textAlign: "center",
                      marginBottom: "-.5vh",
                      color: "#34495E",
                    }}
                  >
                    {item.workflowTypeTitle}
                  </p>
                </StyledTableCell>
                <StyledTableCell align="center" scope="row">
                  <p
                    style={{
                      textAlign: "center",
                      marginBottom: "-.5vh",
                      color: "#34495E",
                    }}
                  >
                    {item.actionDatePersian}
                  </p>
                </StyledTableCell>
                <StyledTableCell align="center" scope="row">
                  <p
                    style={{
                      textAlign: "center",
                      marginBottom: "-.5vh",
                      color: "#34495E",
                    }}
                  >
                    {item.userTitle}
                  </p>
                </StyledTableCell>
                <StyledTableCell align="center" scope="row">
                  <p
                    style={{
                      textAlign: "center",
                      marginBottom: "-.5vh",
                      color:
                        item.workflowStepType === "Backward"
                          ? "#E6123D"
                          : "#28A745",
                    }}
                  >
                    {item.actionTitle}
                  </p>
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  onClick={() => handleMoreClick(item)}
                >
                  <MoreHorizIcon />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default WorkflowTabTable;
